import {
  addUniqueValueToArray
} from 'utils/redux'

import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/Home/view/'
export const INIT = NAMESPACE + 'INIT'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_VISITED_URL = NAMESPACE + 'SET_LAST_VISITED_URL'
export const ADD_LAYOUT = NAMESPACE + 'ADD_LAYOUT'
export const REMOVE_LAYOUT = NAMESPACE + 'REMOVE_LAYOUT'
export const SET_LAYOUTS = NAMESPACE + 'SET_LAYOUTS'
export const SET_USER_GROUPS = NAMESPACE + 'SET_USER_GROUPS'

const initialState = {
  lastVisitedUrl: null,
  layouts: [],
  owners: [],
  isLoading: false,
  isLoaded: false,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
    case INIT:
      return {
        ...initialState,
        ...action.payload,
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading || state.isLoading,
        isLoaded: action.payload.isLoaded || state.isLoaded,
      }
    case SET_LAST_VISITED_URL:
      return action.payload.url !== state.lastVisitedUrl ? {
        ...state,
        lastVisitedUrl: action.payload.url,
      } : state
    case ADD_LAYOUT:
      return {
        ...state,
        layouts: addUniqueValueToArray({
          array: state.layouts,
          value: action.payload.id
        })
      }
    case REMOVE_LAYOUT:
      return state.layouts.indexOf(action.payload.id) !== -1
        ? {
          ...state,
          layouts: state.layouts.filter(layoutId => layoutId !== action.payload.id)
        }
        : state
    case SET_LAYOUTS:
      return {
        ...state,
        layouts: action.payload.layouts
      }
    case SET_USER_GROUPS:
      return {
        ...state,
        ...action.payload.userGroups
      }
    default: return state
  }
}

export function init (payload = initialState) {
  return {
    type: INIT,
    payload
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function setLastVisitedUrl (url) {
  return {
    type: SET_LAST_VISITED_URL,
    payload: {
      url
    }
  }
}

export function addLayout ({ id }) {
  return {
    type: ADD_LAYOUT,
    payload: {
      id
    }
  }
}

export function removeLayout ({ id }) {
  return {
    type: REMOVE_LAYOUT,
    payload: {
      id
    }
  }
}

export function setLayouts ({ layouts }) {
  return {
    type: SET_LAYOUTS,
    payload: {
      layouts
    }
  }
}

export function setUserGroups ({ userGroups }) {
  return {
    type: SET_USER_GROUPS,
    payload: {
      userGroups
    }
  }
}
